// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3uNUp","title":"AfterFrontImage_title__3fmVz"};